import { render, staticRenderFns } from "./ParticipantCasualtyLawyer.vue?vue&type=template&id=4cc4691e"
import script from "./ParticipantCasualtyLawyer.vue?vue&type=script&lang=js"
export * from "./ParticipantCasualtyLawyer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports